import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ShoppingCartStore, CheckoutStore } from '@/stores';
  import { useRoute } from 'vue-router';
  import { onMounted } from 'vue';
  import _ from 'lodash';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const shoppingCartStore = ShoppingCartStore.create<ShoppingCartStore>({
    checkedIds: (route.params.ids as string || '').split(',').map(Number) as number[]
  });
  const store = CheckoutStore.create<CheckoutStore>();

  onMounted(async () => {
    await shoppingCartStore.fetchData();
    store.lineItemsAttributes = shoppingCartStore.getCheckedItems().map(item => _.pick(item, ['quantity', 'variant_id', 'purchase_kind']));
    store.fetchData();
    store.fetchAddresses();
  });


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { store: _unref(store) }, null, 8, ["store"]))
}
}

})